import React from 'react';
import { ArcStack, ArcText } from '@src/core/ui';
import { CARD_SX } from '../../constants';
import type { SummaryStatCardProps } from './types';

export const SummaryStatCard: React.FC<SummaryStatCardProps> = ({ label, value }) => (
  <ArcStack spacing={1} sx={CARD_SX}>
    <ArcText.caption fontSize={16}>{label}</ArcText.caption>
    <ArcText.h2 fontSize={24} fontWeight={700}>{value}</ArcText.h2>
  </ArcStack>
);
